<template>
  <b-row
    class="m-md-3 m-lg-3 text-center"
  >
    <b-col lg="3">
      <b-img
        src="@/assets/images/pages/inicio/1.png"
        alt="Indetec Campus virtual"
        width="100"
        class="pb-2"
      />
      <p class="px-3 pb-2">
        Revisa la sección de
        <b-link to="/oferta-academica">
          oferta académica;
        </b-link>selecciona la especialidad haciendo click en <b>Detalles</b>.</p>
    </b-col>
    <b-col lg="3">
      <b-img
        src="@/assets/images/pages/inicio/2.png"
        alt="Indetec Campus virtual"
        width="100"
        class="pb-2"
      />
      <p class="px-3">
        <b>Solicita tu admisión</b> (haciendo click en el boton), completa el formulario de <b> pre registro.</b></p>
      <p class="px-3 pb-2">
        Revisa la notificación en la bandeja de tu <b>correo electrónico</b> para seguir el proceso.</p>
    </b-col>
    <b-col lg="3">
      <b-img
        src="@/assets/images/pages/inicio/3.png"
        alt="Indetec Campus virtual"
        width="100"
        class="pb-2"
      />
      <p class="px-3">
        En el correo, tendrás un link (enlace) que te habilitará el formulario de registro.</p>
      <p class="px-3 pb-2">
        Es necesario <b>completar el formulario de registro para seguir con el proceso</b>.
      </p>
    </b-col>
    <b-col lg="3">
      <b-img
        src="@/assets/images/pages/inicio/4.png"
        alt="Indetec Campus virtual"
        width="100"
        class="pb-2"
      />
      <p class="px-3">
        <b>Servicio escolar</b> revisará tu información, te contactaremos lo más rápido posible indicando los siguientes pasos a seguir. </p>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BImg, BLink,
} from 'bootstrap-vue'

export default {
  components: {
    BImg,
    BRow,
    BCol,
    BLink,
  },
}
</script>
